import { render, staticRenderFns } from "./OrgLicence.vue?vue&type=template&id=6ec736ca&scoped=true"
import script from "./OrgLicence.vue?vue&type=script&lang=js"
export * from "./OrgLicence.vue?vue&type=script&lang=js"
import style0 from "./OrgLicence.vue?vue&type=style&index=0&id=6ec736ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec736ca",
  null
  
)

export default component.exports